/// <reference path="../../TypeLite.Net4.d.ts" />

export enum FilterActionTypes {
    APPLY_CountryFilter = '@@filter/APPLY_COUNTRY',
    APPLY_WizardFilter = '@@filter/APPLY_WIZARD',
    RESET_All = '@@filter/RESET_ALL'
}

// Declare state types with `readonly` modifier to get compile time immutability.
export interface FilterState {
    readonly defaultCountry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel,
    readonly selectedCountry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel,
    readonly enteredVin: string,
    readonly selectedVehicleMarketEntry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel,
    readonly selectedModel: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel,
    readonly selectedInfotaiment: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel,
    readonly selectedProductionInterval: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel,
    readonly dataFilter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter,
    readonly isCountryManuallySubmitted: boolean
}

export class WizardFilterActionPayload {
    public enteredVin: string;
    public selectedModel: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel;
    public selectedInfotaiment: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel;
    public selectedProductionInterval: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel;
    public selectedVehicleMarketEntry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel;
}

export class CountryFilterActionPayload {
    public selectedCountry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel;
    public isDefault: boolean = false;
    public isManuallySubmitted: boolean = false;
}

